<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ACoQk9/tc-custom/9781528968027.jpg?1737196545514" alt="This image is the cover for the book Into the Valley of the Orcs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Into the Valley of the Orcs
      </h1>
      <p class="bookDescription body article font2">
        <p>Which route will Simon, Tom, and their small army choose to face the least danger? Through the valley of the giant Orcs, risking capture, torture, or worse? Or over the Mountains of Doom, where human-eating spiders lurk? Simon finds himself in this predicament after marrying Elfwyn, who became Queen of Arkadia following her father’s death. Her uncle Athelstan and his knights have driven Simon and Elfwyn back to the safety of Ishtar. After overcoming Athelstan and his followers, Simon meets with the leaders of the Federation to discuss the Orc menace, who are slaughtering inhabitants beyond the Mountains of Doom. Will they conquer the Orcs and bring peace to their neighbours?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Coyne
      </h2>
      
      <p class="authorDescription body article">Charles Coyne was born in Hull, East Riding and educated at Riley High School and Hull Municipal Technical College. After acquiring three degrees, he saw service in the Fleet Air Arm as an Observer. Later, he twice stood as a Member of Parliament and a local government candidate in both Ealing and Leicester. Charles’s career as a management consultant had assignments that took him to Brazil, Venezuela, the USA, and most European countries. During this time, he also produced a number of documents for both the European Commission and the Motor Industry. Now he has retired to the delightful island of Gozo, Malta.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?073e477b